import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const StyledContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  height: "90%",
}));

export const TabBar = styled(Box)(({ theme }) => ({
  display: "flex",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const TabButton = styled("button")<{ $active?: boolean }>(({ theme, $active }) => ({
  padding: `${theme.spacing(1.25)} ${theme.spacing(2.5)}`,
  cursor: "pointer",
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 500,
  border: "none",
  background: "none",
  color: $active ? theme.palette.text.primary : theme.palette.text.secondary,
  borderBottom: $active
    ? `2px solid ${theme.palette.text.primary}`
    : "2px solid transparent",
  marginBottom: -1,
  transition: "color .15s",
}));

export const SectionBox = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius * 1.25,
  padding: theme.spacing(2.5, 3),
  marginBottom: theme.spacing(2),
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 500,
  margin: `0 0 ${theme.spacing(2)}`,
  color: theme.palette.text.primary,
}));

export const FieldLabel = styled("label")(({ theme }) => ({
  display: "block",
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 500,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.75),
}));

export const FieldNote = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  color: theme.palette.text.disabled,
  marginTop: theme.spacing(0.5),
}));

export const StyledInput = styled("input")(({ theme }) => ({
  width: "100%",
  padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
  fontSize: theme.typography.body2.fontSize,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.background.default,
  color: theme.palette.text.primary,
  boxSizing: "border-box",
  "&:disabled": {
    opacity: 0.6,
  },
}));

export const StyledTextarea = styled("textarea")(({ theme }) => ({
  width: "100%",
  padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
  fontSize: theme.typography.body2.fontSize,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.background.default,
  color: theme.palette.text.primary,
  boxSizing: "border-box",
  resize: "vertical",
  minHeight: 72,
}));

export const StyledGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const StyledSelectionGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(0.5),
}));

export const CheckboxItem = styled("label")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.text.primary,
  cursor: "pointer",
}));

export const ToggleRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.25),
  marginBottom: theme.spacing(2),
}));

export const StyledDivider = styled("hr")(({ theme }) => ({
  border: "none",
  borderTop: `1px solid ${theme.palette.divider}`,
  margin: `${theme.spacing(2.5)} 0`,
}));

export const SubmitButton = styled("button")(({ theme }) => ({
  padding: `0 ${theme.spacing(2.25)}`,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 600,
  borderRadius: 0,
  boxShadow: "none",
  height: theme.spacing(4.5),
  background: theme.palette.success.light,
  color: "white",
  border: `solid 1px ${theme.palette.success.light}`,
  cursor: "pointer",
  "&:hover": {
    background: theme.palette.success.main,
  },
  "&:disabled": {
    background: theme.palette.common.button.disabled,
    cursor: "not-allowed",
    borderColor: theme.palette.common.button.disabled,
  },
}));

export const AddOrderButton = styled("button")(({ theme }) => ({
  padding: `0 ${theme.spacing(2.25)}`,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 600,
  borderRadius: 0,
  boxShadow: "none",
  height: theme.spacing(4.5),
  background: theme.palette.primary.light,
  color: "white",
  border: `solid 1px ${theme.palette.primary.light}`,
  cursor: "pointer",
  "&:hover": {
    background: theme.palette.primary.main,
  },
  "&:disabled": {
    background: theme.palette.primary.light,
    cursor: "not-allowed",
    borderColor: theme.palette.primary.light,
    opacity: 0.4,
  },
}));

export const OptionalBadge = styled("span")(({ theme }) => ({
  display: "inline-block",
  fontSize: 11,
  fontWeight: 500,
  padding: `2px ${theme.spacing(1)}`,
  borderRadius: 12,
  background: theme.palette.action.hover,
  color: theme.palette.text.disabled,
  marginLeft: theme.spacing(0.75),
}));